import { IAgencyPayload, IAgencyResponseItem } from '@/Interfaces/Agency.interface';
import { IPaginatedApiResponse } from '@/Interfaces/ApiResponse/PaginatedApiResponse.interface';
import { AGENCIES_ENDPOINT } from '@/constants/endpoints';
import { SearchAgenciesPayload } from '@/types/agencies.types';
import axios from 'axios';

export const fetchAgencies = async (
  params: SearchAgenciesPayload,
): Promise<IPaginatedApiResponse<IAgencyResponseItem[]>> => {
  const res = await axios.get(AGENCIES_ENDPOINT, { params });
  return res.data;
};

export const createAgency = async (payload: IAgencyPayload): Promise<IAgencyResponseItem> => {
  const res = await axios.post(AGENCIES_ENDPOINT, payload);
  return res.data;
};

export const updateAgency = async (id: number, payload: IAgencyPayload): Promise<IAgencyResponseItem> => {
  const res = await axios.put(`${AGENCIES_ENDPOINT}/${id}`, payload);
  return res.data;
};
